<script setup>
import { inject } from 'vue';
import Modal from '../Modal.vue';
import Button from '../components/Button.vue';

const confirmationTask = inject('confirmationTask')

</script>

<template>

  <Modal v-if="confirmationTask"
         :title="confirmationTask.title || 'Confirmation'" 
         :full-size="false" :close-btn="false" @close="confirmationTask=null">
    <div class="p-1 flex flex-col items-center justify-center h-full text-center space-y-4">
      <p>{{ confirmationTask.text }}</p>
      <div class="self-end flex gap-3">
        <Button @action="() => confirmationTask=null">cancel</Button>
        <Button @action="() => {confirmationTask.onOK(); confirmationTask=null}" class="btn-primary">OK</Button>
      </div>
    </div>
  </Modal>

</template>